import React from 'react';

interface InfoProps {
    fill?: string;
    width?: number;
    height?: number;
}

export const Info = ({ fill = 'black', width = 16, height = 16 }: InfoProps) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M8 14.5C11.584 14.5 14.5 11.584 14.5 8C14.5 4.41601 11.584 1.5 8 1.5C4.41601 1.5 1.5 4.41601 1.5 8C1.5 11.584 4.41601 14.5 8 14.5ZM8 13.5C4.95703 13.5 2.5 11.043 2.5 8C2.5 4.95703 4.95703 2.5 8 2.5C11.043 2.5 13.5 4.95703 13.5 8C13.5 11.043 11.043 13.5 8 13.5ZM8.5 11V7H7.5L7.5 11H8.5ZM8.5 6V5H7.5V6H8.5Z"
            fill={fill}
        />
    </svg>
);
